import { ContentCard, Success } from 'apps/dashboard/shared/scripts/components';

interface Props {
  cardId: string;
}

const CardCreateSuccess = ({ cardId }: Props) => {
  return (
    <ContentCard>
      <Success
        cardId={cardId}
        primaryLabel="View Card"
        primaryUrl={`/${cardId}`}
        secondaryLabel="Manage Card"
        secondaryUrl={`/dashboard/cards/${cardId}`}
      >
        Your card is now ready to be signed.
      </Success>
    </ContentCard>
  );
};

CardCreateSuccess.displayName = 'CardCreateSuccess';

export default CardCreateSuccess;
